import Footer from "../Component/Footer";
import MenuBar from "../Component/MenuBar";
import Sidebar from '../Component/Sidebar';
import { NavLink } from "react-router-dom";

const Janmashtami = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* <!-- Page Banner Section --> */}
            <section className="page-banner">
                <div className="image-layer" style={{ backgroundImage: 'url(https://sevastorage.blob.core.windows.net/seva-blob/Yugalkunj_website/background/bg-page-title-2.jpg)' }}></div>

                <div className="auto-container">
                    <h1>Grand Janmashtami Celebrations</h1>
                </div>

                <div className="breadcrumb-box">
                    <div className="auto-container">
                        <ul className="bread-crumb clearfix">
                            <li><NavLink to="/USA/Home">Home</NavLink></li>
                            <li className="active">Grand Janmashtami Celebrations</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/* <!--End Banner Section --> */}

            <div className="container">

                <div className="auto-container">
                    <div className="centered">
                        <hr />
                        <h3> Grand Janmashtami Celebrations 2026 at Yugal Kunj </h3>
                        <h4 className="text-center" style={{ color: "#666", marginTop: "10px" }}>
                            Friday, September 4th &nbsp;|&nbsp; 6:00 PM - Midnight
                        </h4>
                        <h5 className="text-center" style={{ color: "#888", marginTop: "5px" }}>
                            2769 Duluth Hwy, Duluth, GA 30096
                        </h5>
                        <hr />
                    </div>
                </div>

                {/* Main Flyer Section */}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Grand Janmashtami Celebrations 2026</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="widget-49">

                                    <figure className="image">
                                        <img src="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/ad6af72c_janmashtami_Mahotsav.png" alt="Grand Janmashtami Celebrations 2026" style={{ width: "100%" }} />
                                        <a href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/ad6af72c_janmashtami_Mahotsav.png" className="lightbox-image overlay" data-fancybox="gallery-two"></a>
                                    </figure>
                                    <br />
                                    <div className="widget-49-meeting-action">
                                        <a href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/ad6af72c_janmashtami_Mahotsav.png" target="_blank" rel="noreferrer" className="btn btn-sm btn-flash-border-primary">View Flyer</a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Event Highlights Section */}
                <hr />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Event Highlights</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <ul className="satsang_list">
                                        <li><strong>Yugal Kunj Anniversary Retreat</strong></li>
                                        <li><strong>Grand Janmashtami Celebrations</strong></li>
                                        <li><strong>Baby Krishna Jhoola (Swing)</strong></li>
                                        <li><strong>Temple Darshan</strong></li>
                                        <li><strong>AV & Performers</strong></li>
                                        <li><strong>YK Programs & Gift Shop</strong></li>
                                        <li><strong>Food Sales & Prasad</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Schedule Section */}
                <hr />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">✨ Event Schedule</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '15px' }}>
                                        <tbody>
                                            <tr style={{ borderBottom: '1px solid #eee', padding: '8px 0' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#c0392b', whiteSpace: 'nowrap', width: '140px' }}>6:00 pm</td>
                                                <td style={{ padding: '10px 12px' }}>Melodious Keertans &amp; Dance Performances</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee', background: '#fafafa' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#c0392b', whiteSpace: 'nowrap' }}>7:00 pm</td>
                                                <td style={{ padding: '10px 12px' }}>Aarti</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#c0392b', whiteSpace: 'nowrap' }}>8:00 pm</td>
                                                <td style={{ padding: '10px 12px' }}>Cultural Program <br /><span style={{ color: '#666', fontSize: '13px' }}>(Leela Enactment &amp; Professional Dance Performances)</span></td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee', background: '#fafafa' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#c0392b', whiteSpace: 'nowrap' }}>9:00 pm</td>
                                                <td style={{ padding: '10px 12px' }}>Live Dahi Handi</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#c0392b', whiteSpace: 'nowrap' }}>9:30 pm – Midnight</td>
                                                <td style={{ padding: '10px 12px' }}>Melodious Keertan &amp; Bhajan</td>
                                            </tr>
                                            <tr style={{ background: '#fff8e1' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#c0392b', whiteSpace: 'nowrap' }}>Midnight</td>
                                                <td style={{ padding: '10px 12px' }}>Baby Krishna Aarti, Abhishek, Cake Cutting &amp; Celebrations!</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Parking & Map Section */}
                <hr />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Parking Information & Map Guide</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title purple-border">
                                    <h4>Parking Details</h4>
                                    <ul className="satsang_list">
                                        <li><strong>On-site parking:</strong> $15</li>
                                        <li><strong>Free parking + Shuttle Service (5–11 pm):</strong> First Baptist Church<br />
                                            3958 Duluth Hwy, GA 30096
                                        </li>
                                    </ul>
                                </div>

                                <br />

                                <div className="inner_heading_title orange-border">
                                    <h4>Venue Map Guide</h4>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', marginBottom: '16px' }}>
                                        <tbody>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '7px 12px', fontWeight: 'bold', color: '#555', width: '48px' }}>T1</td>
                                                <td style={{ padding: '7px 12px' }}>Bathrooms (Ground Floor)</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee', background: '#fafafa' }}>
                                                <td style={{ padding: '7px 12px', fontWeight: 'bold', color: '#555' }}>T2</td>
                                                <td style={{ padding: '7px 12px' }}>Food Sales &amp; MahaPrasad</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '7px 12px', fontWeight: 'bold', color: '#555' }}>T3</td>
                                                <td style={{ padding: '7px 12px' }}>AV &amp; Performers</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee', background: '#fafafa' }}>
                                                <td style={{ padding: '7px 12px', fontWeight: 'bold', color: '#555' }}>T4</td>
                                                <td style={{ padding: '7px 12px' }}>Baby Krishna Jhoola (Swing)</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '7px 12px', fontWeight: 'bold', color: '#555' }}>T5</td>
                                                <td style={{ padding: '7px 12px' }}>YK Programs / Gift Shop</td>
                                            </tr>
                                            <tr style={{ background: '#fff8e1' }}>
                                                <td style={{ padding: '7px 12px', fontWeight: 'bold', color: '#555' }}>TH</td>
                                                <td style={{ padding: '7px 12px' }}>Temple – Darshan &amp; Baby Krishna Jhoola (Swing)<br /><span style={{ fontSize: '12px', color: '#888' }}>9:00 pm – 12:00 am | 12:00 pm – 12:00 am Satsang</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <figure className="image" style={{ padding: '10px' }}>
                                        <img src="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png" alt="Janmashtami Map Guide 2026" style={{ width: '100%' }} />
                                        <a href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png" className="lightbox-image overlay" data-fancybox="gallery-two"></a>
                                    </figure>
                                    <br />
                                    <div className="widget-49-meeting-action">
                                        <a href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png" target="_blank" rel="noreferrer" className="btn btn-sm btn-flash-border-primary">View Map</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Location Section */}
                <hr />
                <div className="row" style={{ marginBottom: "30px" }}>
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Location</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title purple-border" style={{ paddingLeft: "20px" }}>
                                    <h4>Yugal Kunj</h4>
                                    <p>2769 Duluth Hwy, Duluth, GA 30096</p>
                                    <p><strong>Date:</strong> Friday, September 4th, 2026</p>
                                    <p><strong>Time:</strong> 6:00 PM - Midnight</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <Footer />
        </>
    );
};

export default Janmashtami;
